import { API_ENDPOINTS } from '@/constants/api';
import { api } from '@/shared/api';
import type { ProductOption, RemovalBatch, RemovalBatchFormData } from '../types';

export const removalBatchesApi = {
  getList: async (params?: { perPage?: number; page?: number }) => {
    const response = await api.get<{
      data: RemovalBatch[];
      currentPage: number;
      perPage: number;
      total: number;
      lastPage: number;
    }>(API_ENDPOINTS.REMOVAL_BATCHES.LIST, { params });
    return response.data;
  },

  getOne: async (id: number) => {
    const response = await api.get<{ data: RemovalBatch }>(
      API_ENDPOINTS.REMOVAL_BATCHES.SHOW(id.toString()),
    );
    return response.data.data;
  },

  create: async (data: RemovalBatchFormData) => {
    const response = await api.post<{ data: RemovalBatch }>(
      API_ENDPOINTS.REMOVAL_BATCHES.CREATE,
      data,
    );
    return response.data.data;
  },

  getProducts: async () => {
    const response = await api.get<{ data: ProductOption[] }>(
      API_ENDPOINTS.REMOVAL_BATCHES.PRODUCTS,
    );
    return response.data.data || [];
  },

  update: async (id: number, data: Partial<RemovalBatchFormData>) => {
    const response = await api.put<{ data: RemovalBatch }>(
      API_ENDPOINTS.REMOVAL_BATCHES.UPDATE(id.toString()),
      data,
    );
    return response.data.data;
  },

  delete: async (id: number) => {
    await api.delete(API_ENDPOINTS.REMOVAL_BATCHES.DELETE(id.toString()));
  },
};
